module.exports = __webpack_public_path__ + "static/img/exploit16.00d4f92d.png";